export const SET_CONVERSATIONS="app/consoleConversations/SET_CONVERSATIONS"
export const ADD_MESSAGE="app/consoleConversations/ADD_MESSAGE"
export const REMOVE_CONVERSATION="app/consoleConversations/REMOVE_CONVERSATION"
